import { LmiContractConfig, QualificationType } from './types';

export const nyLmiContractConfig: LmiContractConfig = {
  title: 'Check if you qualify for income-based savings',
  description:
    'You may qualify for additional savings if your household income falls below a certain limit.',
  lmiProofCategory: 'proof_docs',
  fields: [
    {
      name: 'county',
      type: 'select',
      label: 'County',
      required: true,
      placeholder: 'Select county',
    },
    {
      name: 'householdOccupancy',
      type: 'select',
      label: 'Household occupancy',
      required: true,
      placeholder: 'Select an option',
    },
    {
      name: 'qualificationType',
      type: 'radio',
      label: 'Please select one of the options below:',
      header: 'Household income limit',
      description:
        "Based on your household size, your household's gross annual income limit is {incomeLimit}.",
      interpolations: {
        incomeLimit: {
          source: 'variable',
          variableName: 'incomeLimit',
        },
      },
      required: true,
      options: [
        {
          value: QualificationType.INCOME_REJECTED,
          label:
            'My annual household income is above the Household Income Level shown for my household size.',
          enableWhen: {
            allOf: ['county', 'householdOccupancy'],
          },
        },
        {
          value: QualificationType.INCOME,
          label:
            'My annual household income is below the Household Income Level shown for my household size.',
          enableWhen: {
            allOf: ['county', 'householdOccupancy'],
          },
        },
      ],
    },
  ],
  contractLink: {
    preText: 'I have reviewed my',
    postText: '. By proceeding, I will be submitting my e-signature on the',
  },
};
